var map = {
	"./android.png": "558f",
	"./angel.png": "be9c",
	"./apple.png": "4e3d",
	"./chrome.png": "f8eb",
	"./dots.png": "9e06",
	"./dots_1.png": "2d89",
	"./dots_2.png": "12ed",
	"./dots_3.png": "7d7c",
	"./dots_4.png": "6bbd",
	"./down.png": "89fe",
	"./edge.png": "9dd1",
	"./firefox.png": "669e",
	"./hand-mobile.png": "bc45",
	"./hand.png": "5b2c",
	"./linux.png": "9943",
	"./logo-new.png": "1cad",
	"./macos.png": "77e2",
	"./main-mobile.png": "6984",
	"./main.png": "9dad",
	"./map.png": "9585d",
	"./mastercard.png": "6849",
	"./medusa.png": "6a96",
	"./mir.png": "3c64",
	"./oldLogotypes/android.png": "e38d",
	"./oldLogotypes/apple.png": "7610",
	"./oldLogotypes/macos.png": "853d",
	"./opera.png": "10ec",
	"./screenshot_ru.png": "6d7a",
	"./screenshots/ar.png": "b801",
	"./screenshots/de.png": "e171",
	"./screenshots/en.png": "bb4c1",
	"./screenshots/es.png": "b82f",
	"./screenshots/fr.png": "7ebf",
	"./screenshots/he.png": "3c68",
	"./screenshots/hi.png": "4c21",
	"./screenshots/id.png": "d647",
	"./screenshots/ja.png": "4f2b",
	"./screenshots/ko.png": "40d2",
	"./screenshots/nl.png": "845a",
	"./screenshots/pt.png": "6066",
	"./screenshots/ru.png": "50fc",
	"./screenshots/tr.png": "7af2",
	"./screenshots/vi.png": "a898",
	"./screenshots/zh.png": "3d13",
	"./tiki.png": "a8ee",
	"./trustpilot.png": "fb64",
	"./visa.png": "3ced",
	"./windows.png": "530b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d810";